import styles from './PrizeInfo.module.css';
import { ReactNode } from 'react';

type Props = {
  amount: ReactNode;
  amountLabel: ReactNode;
  description: ReactNode;
};

export function PrizeInfo({ amount, amountLabel, description }: Props) {
  return (
    <div className={styles.root}>
      <div className={styles.column}>
        <div className={styles.amount}>{amount}</div>
        <div>{amountLabel}</div>
      </div>
      <div className={styles.column}>{description}</div>
    </div>
  );
}
